import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const OCCUPATION_UPDATE_RESOURCE = "occupation" as const;
export const OCCUPATION_UPDATE_API_PATH = `/v1/${OCCUPATION_UPDATE_RESOURCE}/{uuid}` as const;

export type OccupationUpdateBody =
  paths[typeof OCCUPATION_UPDATE_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type OccupationUpdateResponse =
  paths[typeof OCCUPATION_UPDATE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useOccupationUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<OccupationUpdateResponse, Error, OccupationUpdateBody & { uuid: string }>({
    mutationFn: async (occupation: OccupationUpdateBody & { uuid: string }) => {
      const { uuid, ...rest } = occupation;
      const response = await alphartisApiAxios.patch<OccupationUpdateResponse>(
        `/v1/${OCCUPATION_UPDATE_RESOURCE}/${uuid}`,
        rest,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [OCCUPATION_UPDATE_RESOURCE],
      });
    },
  });
};
